import throttle from 'lodash.throttle';

( function ( $ ) {
	/**
	 * Corrected Nav behavior.
	 */
	$( document ).ready( function () {
		$( '.menu-item-has-children > a' ).after(
			'<button class="sub-menu-toggle" aria-expanded="false" aria-pressed="false"><span class="screen-reader-text">Submenu</span><span class="css-icon arrow-down"></span></button>'
		);
	} );

	$( document ).on( 'click', '.menu-toggle', function () {
		$( this ).toggleClass( 'activated' );
		$( '#genesis-nav-primary' ).slideToggle( 'fast' );
	} );

	$( document ).on( 'click', '.sub-menu-toggle', function () {
		$( this ).toggleClass( 'activated' );
		$( '~ .sub-menu', this ).toggleClass( 'show-sub-menu' );
	} );

	$( document ).on( 'click', '.search-close', function () {
		$( '#header-search' ).toggleClass( 'hidden' );
	} );

	$( document ).ready( function () {
		$( '.menu-item-has-children > a' ).on( 'click', function () {
			var url = $( this ).attr( 'href' );
			// eslint-disable-next-line WordPressVIPMinimum.JS.Window.location
			window.location.href = encodeURI( url ); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
		} );
	} );

	/**
	 * Get screen size from getComputedStyle (so we don't have to define each breakpoint twice)
	 * -- Values are set in CSS --
	 */
	function get_screen_size( sizeString ) {
		var size = window.getComputedStyle( document.body, ':after' ).getPropertyValue( 'content' );

		if ( size && size.indexOf( sizeString ) !== -1 ) {
			return true;
		}
	}

	// Sticky Header
	// ==================================================

	const siteHeader = document.querySelector( '.site-header' );
	const siteContainer = document.querySelector( '.site-container' );
	let isSticky = false; // track state desktop only.

	function updateHeaderBorder() {
		const scrollY = window.scrollY;
		const isDesktop = window.innerWidth >= 1024;

		// Because the Desktop header shrinks on scroll, we need to add the sticky-header for it only.
		if ( isDesktop ) {
			// Desktop: toggle class at 50px/49px scroll
			if ( ! isSticky && scrollY >= 50 ) {
				siteContainer.classList.add( 'sticky-header' );
				isSticky = true;
			} else if ( isSticky && scrollY <= 49 ) {
				siteContainer.classList.remove( 'sticky-header' );
				isSticky = false;
			}
		} else {
			const maxScroll = 11; // after this the border is fully shrunk
			const minScale = 4 / 15; // ≈ 0.267

			const clampedScroll = Math.min( scrollY, maxScroll );
			const scale = 1 - ( clampedScroll / maxScroll ) * ( 1 - minScale );

			siteHeader.style.setProperty( '--border-scale', scale.toFixed( 3 ) );
		}
	}

	window.addEventListener( 'scroll', updateHeaderBorder );
} )( jQuery );
